import { render } from "./DiscountCodes.vue?vue&type=template&id=f0fd253e&scoped=true"
import script from "./DiscountCodes.vue?vue&type=script&lang=js"
export * from "./DiscountCodes.vue?vue&type=script&lang=js"

import "./DiscountCodes.vue?vue&type=style&index=0&id=f0fd253e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fd253e"]])

export default __exports__